import { useQuery } from '@tanstack/react-query';

import { billingInfoRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const useAllCountries = () => {
  const query = useQuery({
    queryKey: [QueryKeys.ALL_COUNTRIES],
    queryFn: billingInfoRepo.getAllCountries,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return useQueryMemoized(query);
};

export type UseAllCountries = ReturnType<typeof useAllCountries>;
